import React, { useCallback } from 'react';

import { useSelector } from 'react-redux';
import Modal from 'components/Modal';

import { isCanvaDesignInProgressSelector } from 'redux/modules/canva';
import { block } from './utils';
import VideoTemplateAddMediaModalContent, {
  VideoTemplateAddMediaModalContentProps,
} from './VideoTemplateAddMediaModalContent';

export interface VideoTemplateAddMediaModalProps
  extends VideoTemplateAddMediaModalContentProps {
  onCancel: () => void;
  onExited: () => void;
  onAnimateGatedClick: () => void;
  show: boolean;
}

const VideoTemplateAddMediaModal: React.FunctionComponent<VideoTemplateAddMediaModalProps> = props => {
  const {
    aspectRatio,
    onAnimateGatedClick,
    onCancel,
    onExited,
    onSubmit,
    show,
  } = props;

  const isDesignInProgress = useSelector(isCanvaDesignInProgressSelector);

  const handleCancel = useCallback(() => {
    if (isDesignInProgress) {
      return;
    }

    onCancel();
  }, [isDesignInProgress, onCancel]);

  return (
    <Modal
      className={block()}
      onExited={onExited}
      onHide={handleCancel}
      show={show}
      title="add media"
    >
      <VideoTemplateAddMediaModalContent
        aspectRatio={aspectRatio}
        onSubmit={onSubmit}
        onAnimateGatedClick={onAnimateGatedClick}
      />
    </Modal>
  );
};

export default VideoTemplateAddMediaModal;
